import { gql } from "@apollo/client";

const UPDATE_TOR = gql`
    mutation updateToR($torID: String!, $studyPeriodStart: String, $studyPeriodEnd: String){
        updateToR(torID: $torID, studyPeriodStart: $studyPeriodStart, studyPeriodEnd: $studyPeriodEnd) 
  }
`;

export default UPDATE_TOR;
